"use strict";
// handles the dropdown menu to chose language.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const languageUtils_1 = require("./languageUtils");
class LanguageSelector {
    constructor() {
        this.currentLanguage = document.querySelector('.eflags__selected');
        this.languageList = document.querySelector('.eflags__nav');
        this.flagsMenu = document.querySelector('.eflags');
        this.languageLinks = document.querySelectorAll('.eflags__nav a');
        this.init();
    }
    init() {
        if (!this.currentLanguage || !this.languageList || !this.flagsMenu) {
            console.warn('Language selector elements not found.');
            return;
        }
        this.currentLanguage.addEventListener('click', () => this.toggleMenu());
        window.addEventListener('resize', () => this.closeMenuOnResize());
        document.body.addEventListener('mousedown', e => this.closeMenuOnClickOutside(e));
        this.languageLinks.forEach(link => link.addEventListener('click', this.handleLanguageChange.bind(this)));
        this.applySavedLanguage();
    }
    toggleMenu() {
        this.languageList?.classList.toggle('eflags__nav--animateLeft');
    }
    closeMenuOnResize() {
        if (this.languageList?.classList.contains('eflags__nav--animateLeft')) {
            this.languageList.classList.remove('eflags__nav--animateLeft');
        }
    }
    closeMenuOnClickOutside(event) {
        if (this.flagsMenu &&
            this.languageList &&
            !this.flagsMenu.contains(event.target)) {
            this.languageList.classList.remove('eflags__nav--animateLeft');
        }
    }
    // private handleLanguageChange(event: Event): void {
    //   event.preventDefault();
    //   const target = event.target as HTMLElement;
    //   const country = target.getAttribute('data-country');
    //   if (country) {
    //     Cookies.set('lang', country);
    //     const bodyElement = document.querySelector('body');
    //     const page = bodyElement ? bodyElement.id : 'index';
    //     // Only add ?lang= if country is NOT 'en'
    //     const url =
    //       country === 'en' ? `${page}.html` : `${page}.html?lang=${country}`;
    //     console.log(`Redirecting to: ${url}`);
    //     window.location.replace(url);
    //   }
    // }
    handleLanguageChange(event) {
        event.preventDefault();
        const target = event.target;
        const country = target.getAttribute('data-country');
        if (!country)
            return;
        // Special handling for "usa"
        const lang = country === 'usa' ? 'en' : country;
        if (country === 'jp' || country === 'cn') {
            const targetDomain = country === 'jp' ? languageUtils_1.BaseDomains.jp : languageUtils_1.BaseDomains.cn;
            let currentPage = document.body.id || 'index';
            currentPage = currentPage === 'gameplay' ? 'system/' : '';
            const newUrl = `${targetDomain}/${currentPage}`;
            // const newUrl = `${targetDomain}`;
            // Redirect without changing query string or cookies for JP and CN
            window.open(newUrl, '_blank');
            return;
        }
        js_cookie_1.default.set('lang', lang);
        const naLanguages = ['en', 'ca'];
        const currentDomain = window.location.hostname;
        const currentPage = document.body.id || 'index';
        const isNA = naLanguages.includes(lang);
        const isLocalhost = currentDomain === 'localhost' ||
            currentDomain.startsWith('master') ||
            currentDomain.startsWith('oct16');
        const targetDomain = isNA ? languageUtils_1.BaseDomains.na : languageUtils_1.BaseDomains.eu;
        const langParam = `?lang=${lang}`;
        const newUrl = `${targetDomain}/${currentPage}.html${langParam}`;
        if (!isLocalhost &&
            !currentDomain.includes(targetDomain.replace('https://', ''))) {
            window.location.href = newUrl;
        }
        else {
            // Stay on local or same domain, update URL
            const url = new URL(location.href);
            url.searchParams.set('lang', lang);
            history.pushState({}, '', url.toString());
            window.location.reload();
        }
    }
    applySavedLanguage() {
        const language = js_cookie_1.default.get('lang');
        if (language) {
            const countryElement = document.querySelector(`[data-country="${language}"]`);
            if (countryElement) {
                countryElement.classList.add('noFlag');
            }
        }
    }
}
exports.LanguageSelector = LanguageSelector;
